import { render, staticRenderFns } from "./deviceBuyManage.vue?vue&type=template&id=85f963cc"
import script from "./deviceBuyManage.vue?vue&type=script&lang=js"
export * from "./deviceBuyManage.vue?vue&type=script&lang=js"
import style0 from "./deviceBuyManage.vue?vue&type=style&index=0&id=85f963cc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports